import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import useUser from "../../hooks/useUser";
// State
import { useStaffCardDetail } from "../../state/staffCardDetailState";
// Components
import { RequestsTable } from "./RequestsTable";
import { CompletedRequestsTable } from "./CompletedRequestsTable";
// MUI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export function RequestHistory() {
  const { user } = useUser();
  const id = user.staffID;

  const [staffDetail, setStaffDetail] = useState({
    filter: {},
    staffdetail: {
      completedOrders: [],
      orders: [],
      draftOrders: [],
      entitlement: [],
      staffsizes: [],
    },
  });

  const { isFetching, isError, isSuccess, error, data } =
    useStaffCardDetail(id);
  // Success Function
  const successFunc = () => setStaffDetail(data.data.data.data.data);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Box>
      <Typography variant="h5" sx={{ pb: 1 }}>
        Request History
      </Typography>
      <Stack spacing={3}>
        <Typography variant="h6" component="h2">
          Approved Requests
        </Typography>
        <RequestsTable data={staffDetail.staffdetail?.orders || []} />
        <Typography variant="h6" component="h2">
          Completed Requests
        </Typography>
        <CompletedRequestsTable
          data={staffDetail.staffdetail?.completedOrders || []}
        />
      </Stack>
    </Box>
  );
}
